import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <div>

    <header className="header">
      <div className="logo">
        <img src="/Logo.png" alt="Company Logo" />
      </div>
      <div className="contact-info">
       
      </div>
    </header>
    <div>

    
    </div>
    </div>
  );
};

export default Header;
